import {IArchivo} from '../interface/IArchivo';

export class Archivo implements IArchivo {

  id: number;
  nombre: string;
  descripcion: string;
  url: string;
  tipo: string;
  entidadId: number;
  entidad: string;
  orden: number;
  fecCreacion: Date;
  fecModificacion: Date;
  esVideo?: boolean;
  previewUrl?: string;

  file?: any;
  nuevo?: boolean;
  antiguoOrden?: number;
  antiguoTipo?: string;
  editado?: boolean;

  nombreProducto?: string;

  constructor(archivo: IArchivo) {
    this.id = archivo.id;
    this.nombre = archivo.nombre;
    this.descripcion = archivo.descripcion;
    this.url = archivo.url;
    this.previewUrl = archivo.url;
    this.tipo = archivo.tipo;
    this.antiguoTipo = archivo.tipo;
    this.entidadId = archivo.entidadId;
    this.entidad = archivo.entidad;
    this.orden = archivo.orden;
    this.antiguoOrden = archivo.orden;
    this.fecCreacion = archivo.fecCreacion;
    this.fecModificacion = archivo.fecModificacion;
    this.nuevo = archivo.nuevo;
    this.editado = archivo.editado;
    this.nombreProducto = archivo.nombreProducto;
  }


  getFormData(): FormData {
    const formData = new FormData();
    if (this.nombre) {
      formData.append('nombre', this.nombre);
    }
    if (this.descripcion) {
      formData.append('descripcion', this.descripcion);
    }
    if (this.url) {
      formData.append('url', this.url);
    }
    if (this.tipo) {
      formData.append('tipo', this.tipo);
    }
    if (this.entidadId) {
      formData.append('entidadId', String(this.entidadId));
    }
    if (this.entidad) {
      formData.append('entidad', this.entidad);
    }
    if (this.orden) {
      formData.append('orden', String(this.orden));
    } else {
      formData.append('orden', '0');
    }
    if (this.file) {
      formData.append('file', this.file, this.file.name);
    }
    if (this.nombreProducto) {
      formData.append('nombreProducto', String(this.nombreProducto));
    }

    return formData;
  }

}



// WEBPACK FOOTER //
// /app/src/model/class/Archivo.ts